import {
  AUTHOR_LIST_LOADING,
  GET_AUTHOR_LIST,
  GET_AUTHOR_LIST_ERROR,
  GET_AUTHOR_BY_ID_LOADING,
  GET_AUTHOR_BY_ID_SUCCESS,
  GET_AUTHOR_BY_ID_ERROR,
  DELETEING_AUTHOR,
  DELETE_AUTHOR,
  DELETE_AUTHOR_ERROR,
  DELETED_AUTHOR_LIST_LOADING,
  GET_DELETED_AUTHOR_LIST,
  GET_DELETED_AUTHOR_LIST_ERROR,
  PERMA_DELETEING_AUTHOR,
  PERMA_DELETE_AUTHOR,
  PERMA_DELETE_AUTHOR_ERROR,
  RESTORE_AUTHOR_LIST_LOADING,
  RESTORE_AUTHOR_LIST,
  RESTORE_AUTHOR_LIST_ERROR
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: AUTHOR_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/blog/author/active`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_AUTHOR_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_AUTHOR_LIST_ERROR,
        payload: error.response,
      })      
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_AUTHOR_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/blog/author/${id}`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_AUTHOR_BY_ID_SUCCESS,
        payload: response,
      })      
    })
    .catch(function (error) {
      dispatch({
        type: GET_AUTHOR_BY_ID_ERROR,
        payload: error.response,
      });
    });
};



export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_AUTHOR_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/blog/author/deleted`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_AUTHOR_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_AUTHOR_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_AUTHOR,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/blog/author/bulk/delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      console.log('response::::::', response);
      dispatch({
        type: DELETE_AUTHOR,
        payload: response,
      })
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_AUTHOR_ERROR,
        payload: error.response,
      })
      message.error(error.response.data.message);
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_AUTHOR,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/blog/author/bulk/perma-delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_AUTHOR,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: PERMA_DELETE_AUTHOR_ERROR,
        payload: error.response,
      })      
      message.success(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: RESTORE_AUTHOR_LIST_LOADING,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/blog/author/bulk/restore`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_AUTHOR_LIST,
        payload: response,
      })
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_AUTHOR_LIST_ERROR,
        payload: error.response,
      })
      message.error(error.response.data.message);
    });
};